// extracted by mini-css-extract-plugin
export default {"header":"financial_header__UIUa-"};